function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 24 C150 24, 90 52, 54 60 V148 C54 214, 102 256, 150 276 C198 256, 246 214, 246 148 V60 C210 52, 150 24, 150 24 Z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 14,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 150,
  width: 92,
  height: 76,
  rx: 14,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 14,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M122 150 V126 C122 108, 136 94, 154 94 C172 94, 186 108, 186 126 V150",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 14,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M150 178 C142 178, 136 184, 136 192 C136 199, 140 204, 146 206 L146 218        C146 220, 148 222, 150 222 C152 222, 154 220, 154 218 L154 206        C160 204, 164 199, 164 192 C164 184, 158 178, 150 178 Z",
  fill: "currentColor"
});

var SvgShieldLock = function SvgShieldLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield-lock.cea59824.svg";
export { ForwardRef as ReactComponent };